var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"github-ribbon"},[_c('a',{attrs:{"target":"_blank","href":"https://github.com/ts1/flipbook-vue"}},[_vm._v("Fork me on GitHub")])])
}]

export { render, staticRenderFns }